export function FernirImage() {
    return (
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_2601_22)">
                <circle cx="60" cy="60" r="50" fill="#F7981A" />
            </g>
            <path
                d="M71.769 27.703C70.2677 26.01 65.8796 25.6798 63.8732 25.7263C66.1093 21.8534 72.6679 21.0724 73.2166 20.2764C73.2166 20.2764 71.7224 25.6966 71.769 27.703Z"
                fill="white"
            />
            <path
                d="M40.3388 69.5C36.7388 85.5 45.5055 100.167 50.3388 105.5C37.1388 96.7 31.1722 76.1667 29.8388 67L29.3388 75.5C22.5388 61.1 32.1722 45.5 37.8388 39.5L30.8388 45.5C35.2388 37.1 43.3388 32.3333 46.8388 31C47.2388 33 48.6722 35.5 49.3388 36.5C45.7388 25.7 56.8388 19 62.8388 17C60.0388 21 61.3388 25.6667 62.3388 27.5C66.8388 28 67.3388 27.5 72.3388 30C78.3388 36.8 89.1722 41.5 93.8388 43C94.5055 43.8333 95.2388 46.4 92.8388 50C84.0388 54.4 80.8388 59.1667 80.3388 61C77.9388 57 87.3388 50.3333 92.3388 47.5C92.3388 47.1667 91.8388 46.5 89.8388 46.5C88.3388 47.5 70.8388 53 68.3388 53.5C66.3388 53.9 61.8388 59.3333 59.8388 62C59.0388 58 63.8388 52 66.3388 49.5C47.1388 57.5 44.0055 73.5 44.8388 80.5C43.6388 79.3 41.3388 72.6667 40.3388 69.5Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_2601_22"
                    x="0"
                    y="0"
                    width="120"
                    height="120"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2601_22" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2601_22"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
